/** Front-end behaviour of the site (built to public/assets/site.js by scripts/build-client.mjs). */
import { initCatalog } from './catalog'
import { initFaq } from './faq'
import { initForms } from './forms'
import { initForminator } from './forminator'
import { initPodbor } from './podbor'
import { initSliders } from './sliders'
import { initUi } from './ui'

const start = () => {
  initUi()
  initForms()
  initSliders()
  initCatalog()
  initForminator()
  initFaq()
  initPodbor()
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start)
else start()
